import { z } from 'zod';
/**
 * Secret fields follow a convention: an empty string means "keep the stored value", not
 * "clear it". That is what lets the form show a masked placeholder without ever
 * receiving the real value from the server.
 */
const secretField = z.string().max(500).optional().nullable();
const plainField = z.string().trim().max(500).optional().nullable();
export const aiyoGatewayConfigSchema = z.object({
    baseUrl: plainField,
    apiKey: plainField,
    apiSecret: secretField,
    username: plainField,
    password: secretField,
    billMasterId: plainField,
    callbackUrl: plainField,
    verifyCallback: z.boolean().optional(),
    expiryMinutes: z.coerce.number().int().min(0).max(43200).optional().nullable(),
});
export const micrositeConfigSchema = z.object({
    baseUrl: plainField,
    apiKey: secretField,
});
export const smtpConfigSchema = z.object({
    host: plainField,
    port: z.coerce.number().int().min(1).max(65535).optional().nullable(),
    secure: z.boolean().optional(),
    username: plainField,
    password: secretField,
    fromEmail: z.string().trim().toLowerCase().email().optional().nullable().or(z.literal('')),
    fromName: plainField,
});
export const storageConfigSchema = z.object({
    endpoint: plainField,
    region: plainField,
    bucket: plainField,
    accessKeyId: plainField,
    secretAccessKey: secretField,
    publicBaseUrl: plainField,
});
export const platformSettingSchema = z.object({
    donorRegistrationRequiresApproval: z.boolean(),
});
/** What the frontend receives for a secret field — a presence marker only. */
export const MASKED = '********';
